// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"5aef825c","527":"2489e329"}[chunkId] + ".chunk.css";
};